// export const BASE_URL = "https://rms-csuw.onrender.com"

export const defaultChartColors = [
    '#4285F4', // Blue
    '#DB4437', // Red
    '#F4B400', // Yellow
    '#0F9D58', // Green
    '#AB47BC', // Purple
    '#26C6DA', // Cyan
    '#EC407A', // Magenta
    '#66BB6A', // Lime
    '#b92f2e', // Orange
    '#306394', // Pink
  ];